import { connect } from 'react-redux'
import BulkAction from './bulk-actions'
import { deleteAssessmentFile } from '../../../../../../stores/assessment/assessment.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = dispatch => ({
  onDelete: ids =>
    ids.forEach(({ id }) =>
      dispatch(deleteAssessmentFile(id)).catch(errorHandler)
    )
})

export default connect(
  null,
  mapDispatchToProps
)(BulkAction)
